import Type1 from "./notes";

export default Type1;
